import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, theme, Typography } from "antd"

import { ROUTE_PATH } from '../../../data/configs/constants'

const ContactOwnerPaywall = () => {
    const {token} = theme.useToken()
    const navigate = useNavigate()

    const handleContactOwner = () => {
        navigate(ROUTE_PATH.SUPPORT)
    }
    
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
        }}>
            <Typography.Text strong>
                To unlock this feature or renew quota, please contact the owner
            </Typography.Text>
            <Button 
                type="primary" 
                size="middle" 
                icon={<i className='ri-customer-service-fill'/>} 
                onClick={handleContactOwner} 
                style={{ fontWeight: 500, marginTop: token.margin }}
            >
                CONTACT OWNER
            </Button>
        </div>
    )
}

export default ContactOwnerPaywall